import { state as accountState } from "./account/state.js";
import { state as customerState } from "./customer/state.js";
import { state as sellInquiryFormState } from "./sellInquiryForm/state.js";
import { state as contractState } from "./contract/state.js";
export default {
	...accountState,
	...customerState,
	...sellInquiryFormState,
	...contractState,
};
